import axiosInstance from '@/utils/api.js'

var state = {
  telDirectionsList: {
    'total': 0,
    'items': []
  },
  telDirections: [],
  allTelDirections: []
}

var getters = {
  TEL_DIRECTIONS_LIST: (state) => {
    return state.telDirectionsList
  },
  ALL_TEL_DIRECTIONS_LIST: (state) => {
    return state.allTelDirections
  },
  TEL_DIRECTIONS: (state) => {
    return state.telDirections
  }
}

var mutations = {
  SET_TEL_DIRECTIONS_LIST: (state, payload) => {
    state.telDirectionsList = payload
  },
  SET_ALL_TEL_DIRECTIONS_LIST: (state, payload) => {
    state.allTelDirections = payload
  },
  SET_TEL_DIRECTIONS: (state, payload) => {
    state.telDirections = payload
  }
}

var actions = {
  GET_TEL_DIRECTIONS_LIST: async (context, payload) => {
    let result = await axiosInstance.put('/tariffing/get_tel_directions', {offset: payload.offset, count: payload.count, filter: payload.filter, excepted_dir_ids: []})
    if (result.status === 200) {
      context.commit('SET_TEL_DIRECTIONS_LIST', result.data)
    }
  },
  GET_ALL_TEL_DIRECTIONS_LIST: async (context, payload) => {
    let result = await axiosInstance.put('/tariffing/get_tel_directions', {offset: 0, count: 1000000, filter: '', excepted_dir_ids: []})
    if (result.status === 200) {
      context.commit('SET_ALL_TEL_DIRECTIONS_LIST', result.data)
    }
  },
  GET_TEL_DIRECTIONS: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/tel_direction?direction_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_TEL_DIRECTIONS', result.data)
    }
  },
  CREATE_TEL_DIRECTIONS: (context, payload) => {
    return axiosInstance.post('/tariffing/tel_direction', payload)
  },
  UPDATE_TEL_DIRECTIONS: (context, payload) => {
    return axiosInstance.put('/tariffing/tel_direction', payload)
  },
  DELETE_TEL_DIRECTIONS: (context, payload) => {
    return axiosInstance.delete('/tariffing/tel_direction?dir_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/tariffing/telDirections.js